// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2-GIN","detailsBorder":"styles_detailsBorder__1tcwE"};